<div class="container" ID="AddAreaContainer">
  <H1>Add Agent</H1>

  <div>
    <div class="form-group">
      <label>Name:</label>
      <input class="form-control" name="Name" type="text" [(ngModel)]="Name" required placeholder="Enter Name"
        maxlength="30" />
    </div>

    <div class="form-group">
      <label>Surname:</label>
      <input class="form-control" name="Surname" type="text" [(ngModel)]="Surname" required placeholder="Enter Surname"
        maxlength="30" />
    </div>

    <div class="form-group">
      <label>Cell Number:</label>
      <input class="form-control" name="Cellnumber" type="text" [(ngModel)]="Cellnumber" required
        placeholder="Enter Cell number" maxlength="30" />
    </div>

    <div class="form-group">
      <label>Code:</label>
      <input class="form-control" name="Code" type="text" [(ngModel)]="Code" required placeholder="Enter Code"
        maxlength="30" />
    </div>

    <div class="form-group">
      <label>Province:</label>

      <select class="form-control" name="Province" type="text" [(ngModel)]="Province" required
        placeholder="Select Province" (change)="ProvinceChanged()">
        <option *ngFor="let Province of Provinces; let i =index" value={{Province}}>{{Province}}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label>Area:</label>
      <select class="form-control" name="Area" type="text" [(ngModel)]="Area" required placeholder="Select Area">
        <option *ngFor="let a of Areas; let i = index" [value]="a.ID">{{a.label}}</option>
      </select>
    </div>

    <div class="form-group">
      <label>Supervisor:</label>

      <select class="form-control" name="Distributor" type="text" [(ngModel)]="Distributor" required
        placeholder="Select Distributor">
        <option *ngFor="let Distributor of Distributors; let i =index" value={{Distributor.ID}}>{{Distributor.label}}
        </option>
      </select>
    </div>


    <div class="form-group bottom-btn-container">
      <div>
        <button class="btn btn-primary btn-lg btn-block" type="submit" ID="AddAgentBackBtn"
          (click)="Back()">Back</button>
      </div>

      <div>
        <button class="btn btn-warning btn-lg btn-block" type="submit" (click)="Reset()">Reset</button>
      </div>

      <div>
        <button class="btn btn-success btn-lg btn-block" type="submit"
          [disabled]="!Name || !Surname || !Cellnumber || !Distributor || !Province || !Area" (click)="Save()">Save</button>
      </div>
    </div>

  </div>

</div>

<div style="float: right;margin-left:20px;">
  <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
  </button>
</div>
<ng-template #content let-modal ID="Errormessage">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{PopupTitle}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">

      <span aria-hidden="true">
        ×
      </span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="dateOfBirth">
          {{DisplayErrormessage}}
        </label>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
      Done
    </button>
  </div>
</ng-template>